<template>
  <div v-if="!isMock" :class="{'chat-input reply-input': uppAnswSno !== ''}" class="chat-input">
    <div class="input-wrap">
      <input
        id="cmntCntnt" autocomplete="off" value=""
        type="text"
        name="cmntCntnt" style="IME-MODE:active;" @keypress.enter="fnInsert"
        @keyup="cmntShowCloseBtn('cmntCntnt', 'closebtn')">
      <button
        id="closebtn" class="btn-clear" type="button"
        style="display:none;"
        @click="cmntClearCloseBtn('cmntCntnt', 'closebtn')"><i class="ico-close"/></button>
    </div>
    <button :disabled="isDisabled" type="button" class="btn-send" @click="fnInsert"><span>Send</span></button>
  </div>
  <div v-else class="chat-input">
    <div class="input-wrap">
      <input
        id="cmntCntnt" autocomplete="off" value=""
        type="text" name="cmntCntnt"
        style="IME-MODE:active;" @keypress.enter="fnMock"
        @keyup="cmntShowCloseBtn('cmntCntnt', 'closebtn')">
      <button
        id="closebtn" class="btn-clear" type="button"
        style="display:none;"
        @click="cmntClearCloseBtn('cmntCntnt', 'closebtn')"><i class="ico-close"/></button>
    </div>
    <button type="button" class="btn-send" @click="fnMock"><span>Send</span></button>
  </div>
</template>
<script>
import { isEmpty } from 'lodash'
export default {
  name: 'ChatInput',
  metaInfo () {
  },
  components: {
  },
  props: {
    isMock: {
      type: Boolean,
      default: false
    },
    cmntList: {
      type: Array,
      default: null
    },
    cmntUuid: {
      type: String,
      required: true,
      default: ''
    }
  },
  data () {
    return {
      uppAnswSno: '',
      wepApcId: this.getStore('mmpAuth').state.session.userId,
      wepId: this.getStore('mmpAuth').state.session.wepId,
      cmntCntntMsg: (this.$t('TEMPLT011') === 'TEMPLT011') ? this.$t('WEP00051') : this.$t('TEMPLT011'),
      sendDisabled: false
    }
  },
  computed: {
    isDisabled: function () {
    	return this.sendDisabled
    }
  },
  watch: {
    uppAnswSno (value) {
      if (value === '') {
        document.getElementById('cmntCntnt').placeholder = this.cmntCntntMsg
      } else {
        document.getElementById('cmntCntnt').placeholder = this.$t('WEP00052')
      }
    }
  },
  mounted () {
    document.getElementById('cmntCntnt').placeholder = this.cmntCntntMsg
  },
  beforeUpdate () {
  },
  updated () {
  },
  async created () {
  },
  methods: {
    async fnMock () {
      this.commAlert(this.$t('WEP00037'))
    },
    async fnInsert () {
      try {
        let cmntCntnt = document.getElementById('cmntCntnt').value.trim()
        if (cmntCntnt === '') {
          this.commAlert(this.$t('WEP00032'))
        } else if (cmntCntnt.length > 500) {
          this.commAlert(this.$t('WEP00049'))
        } else {
          this.sendDisabled = true
          let params = {
            wepApcId: this.wepApcId,
            wepId: this.wepId,
            cmntCntnt: cmntCntnt,
            uppAnswSno: this.uppAnswSno,
            cmntUuid: this.cmntUuid
          }

          this.cmntClearCloseBtn('cmntCntnt', 'closebtn')
          let result = await this.$http.mmp.onAirCommentInsert(this, params)
          if (result.data.status !== 'OK') {
            this.commAlert(this.$t('WEP00027'))
          } else {
            // this.cmntList.push(result.data.data.list[0])
            this.cmntList.push(result.data.data.list2[0])
          }
        }
        this.sendDisabled = false
      } catch (e) {
        this.sendDisabled = false
      }
    },
    cmntClearCloseBtn (arg1, arg2) {
      document.getElementById(arg1).value = ''
      document.getElementById(arg2).style.display = 'none'
      this.uppAnswSno = ''
      this.cmntCntnt = ''
    },
    cmntShowCloseBtn (arg1, arg2) {
      if (this.uppAnswSno !== '') {
        document.getElementById(arg2).style.display = 'block'
      } else {
        if (!isEmpty(document.getElementById(arg1).value)) {
          document.getElementById(arg2).style.display = 'block'
        } else {
          document.getElementById(arg2).style.display = 'none'
        }
      }
    },
    async fnUppCmntSno (uppAnswSno) {
      document.getElementById('cmntCntnt').value = ''

      this.uppAnswSno = uppAnswSno
      this.cmntShowCloseBtn('cmntCntnt', 'closebtn')
      document.getElementById('cmntCntnt').focus()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/ChatInput.vue